import { network } from 'services/network';

export const exportSchedulingResultsAsFile = ({ metaDataId, simulationDate, exportTypeRequest, fileName, key }) => {
    return network
        .post('api/bo/exportSchedulingResultsAsFile', {
            metaDataId,
            simulationDate,
            exportType: exportTypeRequest,
            key,
        })
        .then((response) => {
            const blob = new Blob([response.data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
        });
};
